const faqs = [
  {
    keywords: ['dashboard', 'home', 'main'],
    answer: '🏎️ The Dashboard is your home page. It shows all upcoming races where you can submit your podium picks.',
    link: '/dashboard',
    linkLabel: 'Go to Dashboard',
  },
  {
    keywords: ['pick', 'predict', 'podium', 'submit', 'choose', 'driver'],
    answer: '🏆 To make a pick, go to the Dashboard, click on an upcoming race, then select your 1st, 2nd, and 3rd place drivers. Picks are locked once the race starts!',
    link: '/dashboard',
    linkLabel: 'Make a Pick',
  },
  {
    keywords: ['history', 'predictions', 'past', 'previous', 'my picks'],
    answer: '📋 Your past predictions are on the History page. You can filter by status (completed, upcoming, ongoing) and sort by date.',
    link: '/history',
    linkLabel: 'View History',
  },
  {
    keywords: ['profile', 'account', 'me', 'my profile'],
    answer: '👤 Your Profile page shows your account info and a summary of your completed predictions.',
    link: '/profile',
    linkLabel: 'View Profile',
  },
  {
    keywords: ['leaderboard', 'rankings', 'points', 'score', 'rank'],
    answer: '🏆 The Standings page shows your group leaderboards. Join or create a group to compete with friends — the more accurate your picks, the higher you climb!',
    link: '/leaderboard',
    linkLabel: 'View Standings',
  },
  {
    keywords: ['group', 'friends', 'private', 'invite'],
    answer: '👥 Groups let you compete with friends privately. Go to Groups to create one, invite people by email, see your group leaderboard, and view other members\' pick history for completed races.',
    link: '/groups',
    linkLabel: 'View Groups',
  },
  {
    keywords: ['member picks', 'other picks', 'view picks', 'see picks', 'their picks', 'friend picks', 'member history'],
    answer: '👀 You can view other group members\' pick history for completed races! Go to the Groups page, find your group, and click "View Picks" next to any member\'s name.',
    link: '/groups',
    linkLabel: 'Go to Groups',
  },
  {
    keywords: ['login', 'sign in', 'google', 'auth'],
    answer: '🔐 Sign in using your Google account. Click the "Sign in with Google" button on the login page.',
    link: '/login',
    linkLabel: 'Go to Login',
  },
  {
    keywords: ['lock', 'locked', 'deadline', 'change', 'edit'],
    answer: '🔒 Picks are automatically locked before race start time to keep things fair. Make sure to submit before the race begins!',
  },
  {
    keywords: ['scoring', 'how many points', 'point system'],
    answer: '🎯 Points are awarded based on how accurate your podium predictions are. Correct driver in the correct position earns the most points!',
  },
  {
    keywords: ['race', 'races', 'upcoming', 'schedule', 'when'],
    answer: '📅 Upcoming races are shown on your Dashboard. Click any race card to see full details and submit your picks.',
    link: '/dashboard',
    linkLabel: 'View Races',
  },
  {
    keywords: ['driver', 'drivers', 'who'],
    answer: '🧑‍🏎️ You can click on any driver\'s name throughout the app to see their detail page with stats and history.',
  },
  {
    keywords: ['help', 'how', 'what', 'explain', 'guide'],
    answer: '👋 I can help with: navigating the site, making picks, viewing your history, the leaderboard, groups, and scoring. What do you need help with?',
  },
];

export function getBotResponse(input) {
  const lower = input.toLowerCase();
  const match = faqs.find(faq =>
    faq.keywords.some(keyword => lower.includes(keyword))
  );
  return match || {
    answer: "🤖 I'm not sure about that. Try asking about: picks, dashboard, history, leaderboard, groups, or scoring!",
  };
}
